import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.scss";
import { Provider } from "react-redux";
import { store } from "./shared/store";

const element = document.getElementById("root");
if (!element) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(element);
root.render(

  <Provider store={store}>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  </Provider>
);